/***************************
    SCSS
****************************/

import './assets/src/scss/main.scss';



/***************************
    Scripts
****************************/

import './assets/src/js/main.js';